import { Link } from "react-router-dom";

const REG_VERSION = "v1";
const REG_DATE = "9 maja 2026";

export function Regulamin() {
  return (
    <article className="max-w-4xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
      <header className="mb-10">
        <p className="chip mb-3">DOKUMENT</p>
        <h1 className="font-display font-bold text-4xl sm:text-5xl tracking-tight">
          Regulamin sprzedaży <span className="text-carp-primary">MudCarp</span>
        </h1>
        <p className="mt-3 text-sm font-mono text-carp-ink/70">
          Wersja {REG_VERSION} · obowiązuje od {REG_DATE}
        </p>
      </header>

      <div className="brut bg-carp-paper p-6 sm:p-8 space-y-10 text-[15px] leading-relaxed text-carp-ink">
        <Section number="1" title="Postanowienia ogólne i definicje">
          <Ol>
            <Li>
              Niniejszy regulamin (dalej: „<b>Regulamin</b>”) określa zasady sprzedaży usługi „Odpowiedź MudCarp” oraz produktu
              „MudCarp Device” za pośrednictwem strony internetowej dostępnej pod adresem{" "}
              <b>https://mudcarp.pl</b> (dalej: „<b>Serwis</b>”), prowadzonej przez Sprzedawcę.
            </Li>
            <Li>
              <b>Sprzedawca</b> — Tailored Apps Łukasz Kowalski, jednoosobowa działalność gospodarcza wpisana do CEIDG,
              ul. Gliniana 52A, 91-336 Łódź, NIP: PL7282614483, e-mail: <Mail />.
              Sprzedawca jest jedynym podmiotem przyjmującym płatności i świadczącym usługę — w transakcji nie uczestniczy
              żaden pośrednik ani odbiorca końcowy środków poza Sprzedawcą.
            </Li>
            <Li>
              <b>Klient</b> — osoba fizyczna posiadająca pełną zdolność do czynności prawnych, osoba prawna lub jednostka
              organizacyjna, która składa zamówienie w Serwisie.
            </Li>
            <Li>
              <b>Konsument</b> — Klient będący osobą fizyczną dokonującą ze Sprzedawcą czynności prawnej niezwiązanej bezpośrednio
              z jej działalnością gospodarczą lub zawodową.
            </Li>
            <Li>
              <b>Przedsiębiorca-konsument</b> — Klient prowadzący jednoosobową działalność gospodarczą, dla którego umowa nie
              ma charakteru zawodowego (art. 7aa ustawy o prawach konsumenta) — w zakresie określonym ustawą stosuje się do
              niego przepisy dotyczące Konsumenta.
            </Li>
            <Li>
              <b>Odpowiedź MudCarp</b> — treść cyfrowa: krótka wypowiedź ułożona przez model językowy Claude (Anthropic)
              i odtworzona głosem syntetycznym (ElevenLabs), będąca reakcją na Wiadomość Klienta, transmitowana w czasie
              rzeczywistym do podpiętych urządzeń MudCarp Device oraz, jeśli prowadzona jest transmisja na żywo (np. na
              platformie Kick), słyszalna na tej transmisji.
            </Li>
            <Li>
              <b>MudCarp Device</b> — fizyczne urządzenie audio (płytka ESP32-S3 z mikrofonem, głośnikiem i radarem mmWave)
              oferowane wyłącznie w ramach przedsprzedaży opisanej w §4.
            </Li>
            <Li>
              <b>Wiadomość</b> — treść tekstowa o długości do 500 znaków, którą Klient przekazuje Sprzedawcy w celu
              zrealizowania Odpowiedzi MudCarp.
            </Li>
            <Li>
              <b>Stripe</b> — Stripe Payments Europe, Limited, z siedzibą w Irlandii, operator usługi płatniczej obsługującej
              płatności kartą, BLIK oraz Przelewy24.
            </Li>
          </Ol>
        </Section>

        <Section number="2" title="Wymagania techniczne">
          <Ol>
            <Li>
              Korzystanie z Serwisu wymaga: urządzenia z dostępem do Internetu, aktualnej przeglądarki (Chrome, Firefox,
              Safari, Edge), włączonej obsługi JavaScript i niezbędnych plików cookies.
            </Li>
            <Li>
              Do realizacji płatności wymagane jest aktywne konto bankowe lub karta płatnicza akceptowana przez Stripe albo
              aplikacja bankowa obsługująca BLIK.
            </Li>
            <Li>
              Wysłuchanie Odpowiedzi MudCarp w transmisji wymaga dostępu do strumienia transmisji prowadzonego przez Sprzedawcę.
              Sprzedawca nie gwarantuje konkretnych godzin, ciągłości ani dostępności transmisji.
            </Li>
          </Ol>
        </Section>

        <Section number="3" title="Zakres usługi „Odpowiedź MudCarp” i sposób realizacji">
          <Ol>
            <Li>
              W ramach Odpowiedzi MudCarp Klient nabywa prawo do jednorazowej reakcji systemu MudCarp na swoją Wiadomość.
              Reakcja przyjmuje formę krótkiej wypowiedzi głosowej (zwykle 1–4 zdania), generowanej przez model językowy
              w stylu charakterystycznym dla persony „MudCarp” (sarkastyczny, bezpośredni).
            </Li>
            <Li>
              Wypowiedź jest transmitowana na żywo do wszystkich aktualnie podłączonych urządzeń MudCarp Device w sieci
              Sprzedawcy oraz odtwarzana w transmisji na żywo, jeżeli transmisja jest prowadzona w momencie realizacji
              zamówienia.
            </Li>
            <Li>
              Sprzedawca nie gwarantuje konkretnego czasu odtworzenia Wiadomości — Wiadomość zostaje odtworzona niezwłocznie
              po zaksięgowaniu płatności, zazwyczaj w ciągu kilku sekund. Jeżeli w momencie zaksięgowania płatności nie jest
              prowadzona transmisja, Wiadomość zostaje odtworzona przy najbliższej okazji.
            </Li>
            <Li>
              Treść Odpowiedzi MudCarp układana jest automatycznie przez model językowy na podstawie persony Sprzedawcy
              i Wiadomości Klienta. Sprzedawca nie ma wpływu na konkretną treść wypowiedzi modelu i nie gwarantuje, że
              wypowiedź odniesie się dosłownie do Wiadomości lub spełni oczekiwania Klienta co do dokładnej treści,
              długości lub tonu.
            </Li>
            <Li>
              Klient akceptuje, że:
              <Ul>
                <li>Wiadomość przekazana Sprzedawcy może zostać publicznie odtworzona (na transmisji na żywo);</li>
                <li>Wiadomość będzie przetwarzana przez podmioty trzecie wymienione w §7;</li>
                <li>Wiadomość staje się elementem treści transmisji i może zostać zarchiwizowana razem z nią.</li>
              </Ul>
            </Li>
          </Ol>
        </Section>

        <Section number="4" title="Przedsprzedaż MudCarp Device">
          <Ol>
            <Li>
              Wpłata kwoty <b>10 000 PLN</b> traktowana jest jako zamówienie przedsprzedażowe MudCarp Device w wersji v1
              i obejmuje:
              <Ul>
                <li>jeden egzemplarz fizycznego urządzenia MudCarp Device,</li>
                <li>
                  prawo do nielimitowanej liczby Odpowiedzi MudCarp przez okres 12 miesięcy od dnia premiery, na zasadach
                  określonych w odrębnym dokumencie subskrypcji udostępnianym przed startem usługi.
                </li>
              </Ul>
            </Li>
            <Li>
              Planowana data premiery MudCarp Device: <b>1 września 2026</b>. Wysyłka nastąpi nie później niż 14 dni przed
              datą premiery.
            </Li>
            <Li>
              Wysyłka realizowana jest na terytorium Rzeczypospolitej Polskiej za pośrednictwem firmy kurierskiej. Wysyłka
              zagraniczna — po indywidualnym ustaleniu poprzez kontakt mailowy.
            </Li>
            <Li>
              W przypadku odwołania przedsprzedaży lub niemożności jej zrealizowania, Sprzedawca zwraca pełną wpłaconą
              kwotę na rachunek, z którego dokonano płatności, w terminie 14 dni.
            </Li>
            <Li>
              Szczegółowe warunki subskrypcji rocznej (cennik dalszych okresów, limity, zasady przedłużenia) zostaną
              opublikowane przed datą premiery; ich akceptacja nie jest wymagana do skorzystania z 12-miesięcznego okresu
              objętego ceną przedsprzedaży.
            </Li>
          </Ol>
        </Section>

        <Section number="5" title="Składanie zamówień i zawarcie umowy">
          <Ol>
            <Li>
              Zamówienie składa się przez wypełnienie formularza dostępnego pod adresem <Link to="/buy" className="link-brut">/buy</Link>{" "}
              w Serwisie: podanie adresu e-mail, opcjonalnego imienia, treści Wiadomości oraz wybór kwoty (od 5 do 10 000 PLN)
              i kanału płatności.
            </Li>
            <Li>
              Złożenie zamówienia wymaga zaakceptowania niniejszego Regulaminu oraz wyrażenia zgody na natychmiastowe
              rozpoczęcie świadczenia treści cyfrowej (zob. §8).
            </Li>
            <Li>
              Umowa zostaje zawarta z chwilą zaksięgowania płatności po stronie Sprzedawcy. Z tą chwilą Sprzedawca przystępuje
              do realizacji usługi.
            </Li>
            <Li>
              Klient otrzymuje na podany adres e-mail potwierdzenie zawarcia umowy. Faktura VAT wystawiana jest na życzenie
              Klienta — wystarczy odpowiedź na wiadomość potwierdzającą z prośbą o fakturę i wskazaniem danych do faktury.
            </Li>
          </Ol>
        </Section>

        <Section number="6" title="Płatności">
          <Ol>
            <Li>
              Wszystkie ceny w Serwisie podane są w polskich złotych (PLN) i stanowią ceny brutto (zawierają należny
              podatek VAT, jeśli ma zastosowanie).
            </Li>
            <Li>
              Płatności obsługiwane są wyłącznie przez Stripe poprzez stronę checkout.stripe.com. Dostępne metody płatności:
              karta płatnicza (Visa, Mastercard, American Express), BLIK, Przelewy24.
            </Li>
            <Li>
              Klient nie dokonuje płatności bezpośrednio na rachunek Sprzedawcy ani żadnego pośrednika; rozliczenie odbywa się
              wyłącznie przez Stripe na warunkach określonych w regulaminie usługi Stripe.
            </Li>
            <Li>
              Środki z każdej płatności są kierowane wyłącznie do Sprzedawcy. W transakcji nie uczestniczą podmioty trzecie
              pełniące rolę pośrednika finansowego ani odbiorcy końcowego środków.
            </Li>
          </Ol>
        </Section>

        <Section number="7" title="Podmioty trzecie uczestniczące w realizacji">
          <p>
            W realizacji usługi uczestniczą — wyłącznie jako dostawcy infrastruktury technicznej — następujące podmioty:
          </p>
          <Ul>
            <li>
              <b>Stripe Payments Europe, Limited</b> — obsługa płatności (siedziba: Irlandia, podlega RODO);
            </li>
            <li>
              <b>Anthropic, PBC</b> — operator modelu językowego Claude generujący tekst Odpowiedzi MudCarp (siedziba: USA;
              dane przekazywane na podstawie standardowych klauzul umownych UE);
            </li>
            <li>
              <b>ElevenLabs, Inc.</b> — operator syntezatora mowy generującego głos Odpowiedzi MudCarp (siedziba: USA; SCC);
            </li>
            <li>
              <b>Insert Sp. z o.o. (Subiekt 123)</b> — system fakturowania, używany wyłącznie gdy Klient zażąda faktury VAT
              (siedziba: Polska);
            </li>
            <li>
              operator infrastruktury hostingowej Serwisu i backendu MudCarp.
            </li>
          </Ul>
          <p>
            Szczegółowy zakres przekazywanych danych opisuje{" "}
            <Link to="/polityka-prywatnosci" className="link-brut">
              Polityka Prywatności
            </Link>
            .
          </p>
        </Section>

        <Section number="8" title="Treść cyfrowa — zgoda na rozpoczęcie świadczenia, wyłączenie prawa odstąpienia">
          <Ol>
            <Li>
              Odpowiedź MudCarp stanowi <b>treść cyfrową dostarczaną nie na nośniku materialnym</b> w rozumieniu art. 38 ust. 13
              ustawy z dnia 30 maja 2014 r. o prawach konsumenta (Dz.U. 2014 poz. 827 ze zm.).
            </Li>
            <Li>
              Składając zamówienie, Konsument <b>wyraża wyraźną i uprzednią zgodę</b> na rozpoczęcie spełniania świadczenia
              przed upływem 14-dniowego terminu na odstąpienie od umowy oraz <b>przyjmuje do wiadomości, że tym samym traci
              prawo odstąpienia</b> od umowy zawartej na odległość (art. 38 ust. 13 ustawy o prawach konsumenta).
            </Li>
            <Li>
              Zgoda, o której mowa w ust. 2, stanowi warunek zawarcia umowy i jest udzielana przez zaznaczenie odpowiedniego
              pola w formularzu zamówienia.
            </Li>
            <Li>
              Postanowienia ust. 1–3 <b>nie dotyczą</b> przedsprzedaży MudCarp Device opisanej w §4 — w odniesieniu do
              urządzenia stosuje się ogólne zasady prawa odstąpienia (14 dni od otrzymania urządzenia), z zastrzeżeniem ust. 5.
            </Li>
            <Li>
              W przypadku zwrotu MudCarp Device na podstawie ust. 4 Klient odsyła urządzenie na własny koszt; Sprzedawca zwraca
              cenę urządzenia po jego otrzymaniu i sprawdzeniu stanu technicznego. Część dotycząca prawa do Odpowiedzi MudCarp,
              jeżeli została skonsumowana w całości lub w części przed odstąpieniem, podlega rozliczeniu proporcjonalnie.
            </Li>
          </Ol>
        </Section>

        <Section number="9" title="Niedozwolone treści Wiadomości">
          <Ol>
            <Li>
              Klient zobowiązuje się nie przekazywać w Wiadomości treści:
              <Ul>
                <li>zawierających dane osobowe osób trzecich bez ich zgody (zwłaszcza adresów, numerów telefonów, danych identyfikacyjnych);</li>
                <li>stanowiących mowę nienawiści, groźby, wezwania do przemocy lub treści o charakterze pornograficznym;</li>
                <li>naruszających przepisy prawa, w tym prawa autorskie osób trzecich;</li>
                <li>zawierających reklamę lub niezamówione treści komercyjne.</li>
              </Ul>
            </Li>
            <Li>
              Sprzedawca zastrzega sobie prawo odmowy realizacji Odpowiedzi MudCarp w przypadku Wiadomości naruszającej ust. 1,
              ze zwrotem wpłaconej kwoty.
            </Li>
            <Li>
              Charakter persony „MudCarp” zakłada wypowiedzi bezpośrednie, sarkastyczne i czasami uszczypliwe. Klient akceptuje,
              że wygenerowana wypowiedź może mieć charakter niepochlebny, ironiczny lub krytyczny względem treści Wiadomości —
              taki charakter usługi nie stanowi podstawy reklamacji.
            </Li>
          </Ol>
        </Section>

        <Section number="10" title="Reklamacje">
          <Ol>
            <Li>
              Reklamacje dotyczące realizacji usługi można zgłaszać:
              <Ul>
                <li>drogą elektroniczną na adres: <Mail />,</li>
                <li>listownie na adres siedziby Sprzedawcy.</li>
              </Ul>
            </Li>
            <Li>
              Reklamacja powinna zawierać: dane Klienta, identyfikator zamówienia (numer otrzymany w wiadomości potwierdzającej),
              opis problemu i oczekiwane rozstrzygnięcie.
            </Li>
            <Li>
              Sprzedawca rozpatruje reklamację w terminie nie dłuższym niż <b>14 dni</b> (jeśli Klient jest Konsumentem
              lub Przedsiębiorcą-konsumentem) lub 30 dni w pozostałych przypadkach, licząc od dnia jej otrzymania.
            </Li>
            <Li>
              W przypadku braków uniemożliwiających rozpatrzenie reklamacji Sprzedawca może zwrócić się do Klienta o uzupełnienie
              danych w terminie 3 dni roboczych.
            </Li>
          </Ol>
        </Section>

        <Section number="11" title="Pozasądowe rozwiązywanie sporów">
          <Ol>
            <Li>
              Konsument ma prawo do pozasądowego rozwiązywania sporów konsumenckich, w tym za pośrednictwem platformy ODR
              Komisji Europejskiej dostępnej pod adresem{" "}
              <ExtLink href="https://ec.europa.eu/consumers/odr">ec.europa.eu/consumers/odr</ExtLink>.
            </Li>
            <Li>Adres e-mail Sprzedawcy do platformy ODR: <Mail />.</Li>
            <Li>Skorzystanie z pozasądowych metod jest dobrowolne i wymaga zgody obu stron.</Li>
          </Ol>
        </Section>

        <Section number="12" title="Własność intelektualna">
          <Ol>
            <Li>
              Wszystkie elementy Serwisu (grafiki, kod, treści, znaki towarowe „MudCarp”, projekt urządzenia) są własnością
              Sprzedawcy i podlegają ochronie prawnej.
            </Li>
            <Li>
              Klient otrzymuje niewyłączną, niezbywalną licencję na osobiste, niekomercyjne odsłuchanie Odpowiedzi MudCarp
              dotyczącej jego Wiadomości. Licencja nie obejmuje prawa do dalszej dystrybucji, odsprzedaży ani komercyjnego
              wykorzystania nagrania.
            </Li>
            <Li>
              Sprzedawca zachowuje prawo do publikowania Odpowiedzi MudCarp jako elementu transmisji na żywo i archiwów
              transmisji bez dodatkowego wynagrodzenia dla Klienta.
            </Li>
          </Ol>
        </Section>

        <Section number="13" title="Odpowiedzialność">
          <Ol>
            <Li>
              Sprzedawca nie ponosi odpowiedzialności za przerwy w działaniu Serwisu spowodowane okolicznościami od niego
              niezależnymi (awarie infrastruktury, działania siły wyższej, awarie u dostawców usług trzecich).
            </Li>
            <Li>
              W odniesieniu do Klientów niebędących Konsumentami ani Przedsiębiorcami-konsumentami odpowiedzialność Sprzedawcy
              ograniczona jest do wartości zamówienia.
            </Li>
            <Li>
              Sprzedawca nie odpowiada za działania platform transmisyjnych (Kick i in.) ani za dostępność Klienta na transmisji
              w momencie odtworzenia Wiadomości.
            </Li>
          </Ol>
        </Section>

        <Section number="14" title="Postanowienia końcowe">
          <Ol>
            <Li>
              W sprawach nieuregulowanych Regulaminem stosuje się przepisy prawa polskiego, w szczególności Kodeksu cywilnego,
              ustawy o prawach konsumenta oraz ustawy o świadczeniu usług drogą elektroniczną.
            </Li>
            <Li>
              Sprzedawca zastrzega prawo do zmiany Regulaminu z zachowaniem 14-dniowego okresu wypowiedzenia. Zmiana nie ma
              wpływu na umowy zawarte przed datą wejścia w życie zmienionego Regulaminu — do tych umów stosuje się Regulamin
              obowiązujący w dniu złożenia zamówienia.
            </Li>
            <Li>
              Klient w momencie składania zamówienia akceptuje wersję Regulaminu obowiązującą w dniu złożenia zamówienia
              (numer wersji jest utrwalany w danych zamówienia).
            </Li>
            <Li>
              Aktualna wersja: <b>{REG_VERSION}</b>, data wejścia w życie: <b>{REG_DATE}</b>.
            </Li>
          </Ol>
        </Section>

        <footer className="pt-6 border-t-[3px] border-carp-ink/20 flex flex-wrap items-center justify-between gap-4 text-sm">
          <Link to="/polityka-prywatnosci" className="link-brut">
            → Polityka prywatności
          </Link>
          <Link to="/buy" className="btn-primary">
            Wracam do formularza
          </Link>
        </footer>
      </div>
    </article>
  );
}

// ─── Local helpers ──────────────────────────────────────────

function Section({ number, title, children }: { number: string; title: string; children: React.ReactNode }) {
  return (
    <section className="space-y-4">
      <h2 className="font-display font-bold text-2xl tracking-tight">
        <span className="text-carp-primary">§{number}</span> {title}
      </h2>
      <div className="space-y-3">{children}</div>
    </section>
  );
}

function Ol({ children }: { children: React.ReactNode }) {
  return <ol className="list-decimal pl-6 space-y-3 marker:font-mono marker:text-carp-ink/60">{children}</ol>;
}

function Li({ children }: { children: React.ReactNode }) {
  return <li className="leading-relaxed">{children}</li>;
}

function Ul({ children }: { children: React.ReactNode }) {
  return <ul className="list-disc pl-6 space-y-1 mt-2 marker:text-carp-ink/40">{children}</ul>;
}

function Mail() {
  return (
    <a href="mailto:kontakt@mudcarp.pl" className="link-brut">
      kontakt@mudcarp.pl
    </a>
  );
}

function ExtLink({ href, children }: { href: string; children: React.ReactNode }) {
  return (
    <a href={href} target="_blank" rel="noreferrer noopener" className="link-brut">
      {children}
    </a>
  );
}

export default Regulamin;
